import { render } from "./videogallary.vue?vue&type=template&id=ce89c7bc&scoped=true"
import script from "./videogallary.vue?vue&type=script&lang=js"
export * from "./videogallary.vue?vue&type=script&lang=js"

import "./videogallary.vue?vue&type=style&index=0&id=ce89c7bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce89c7bc"]])

export default __exports__